const WaitingStepsCard = () => {
  return (
    <div className="bg-white border border-[#EBEBEB] rounded-xl p-8 mb-6 shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
      <h2 className="text-[11px] font-bold tracking-[0.1em] text-[#808080] uppercase mb-8">
        WHAT HAPPENS NEXT
      </h2>

      <div className="space-y-8">
        {/* Step 1 */}
        <div className="flex gap-4">
          <div className="flex-shrink-0 mt-0.5">
            <div className="h-8 w-8 rounded-full bg-[#F5F5F5] flex items-center justify-center text-[#4A4A4A] font-semibold text-[15px]">
              1
            </div>
          </div>
          <div>
            <h3 className="text-[16px] font-semibold text-[#1A1A1A] mb-1">
              Verification — 24 to 48 hours
            </h3>
            <p className="text-[15px] text-[#666666]">
              Our team reviews your profile.
            </p>
          </div>
        </div>

        {/* Step 2 */}
        <div className="flex gap-4">
          <div className="flex-shrink-0 mt-0.5">
            <div className="h-8 w-8 rounded-full bg-[#F5F5F5] flex items-center justify-center text-[#4A4A4A] font-semibold text-[15px]">
              2
            </div>
          </div>
          <div>
            <h3 className="text-[16px] font-semibold text-[#1A1A1A] mb-1">
              You get your login
            </h3>
            <p className="text-[15px] text-[#666666]">
              We'll email you access to your agent dashboard at agent.trrip.live
            </p>
          </div>
        </div>

        {/* Step 3 */}
        <div className="flex gap-4">
          <div className="flex-shrink-0 mt-0.5">
            <div className="h-8 w-8 rounded-full bg-[#F5F5F5] flex items-center justify-center text-[#4A4A4A] font-semibold text-[15px]">
              3
            </div>
          </div>
          <div>
            <h3 className="text-[16px] font-semibold text-[#1A1A1A] mb-1">
              15-minute onboarding call
            </h3>
            <p className="text-[15px] text-[#666666] leading-relaxed">
              Your Relationship Manager will walk you through the platform and set up your first client voucher live on the call.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaitingStepsCard;
